
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Product } from '@/types/common';

// Since the database function now returns complete product data, use the full Product type
export type OnSaleProduct = Product;

const fetchOnSaleProducts = async (): Promise<OnSaleProduct[]> => {
  const { data, error } = await supabase.rpc('get_on_sale_products', {
    product_limit: 10,
  });

  if (error) {
    console.error('Error fetching on-sale products:', error);
    throw new Error(error.message);
  }

  // Cast the data as Product[] since our database function returns complete product data
  return (data as unknown) as OnSaleProduct[];
};

export const useOnSaleProducts = () => {
  return useQuery({
    queryKey: ['on-sale-products'],
    queryFn: fetchOnSaleProducts,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
